module.exports = __webpack_public_path__ + "static/img/85.6326cd22.png";